import { useMount } from "app/custom-hooks/useMount";
import type React from "react";
import { useDispatch } from "react-redux";
import { getSalesforceStatusThunk } from "../../store/effects/salesforce/status";

const withSalesforceStatusCall = <P extends Record<string, unknown>>(Component: React.ComponentType<P>) => {
    return function WrappedWithSfCall(props: P) {
        const dispatch = useDispatch();

        useMount(() => {
            dispatch(getSalesforceStatusThunk());
        });

        return <Component {...props} />;
    };
};

export default withSalesforceStatusCall;
